/**
 * Register page — Beta invitation notice.
 *
 * During the beta period, developer accounts are created by platform admins.
 * This page informs visitors and provides contact options to request access.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { UserPlus, Mail, ArrowLeft, ShieldCheck } from 'lucide-react';

export default function RegisterPage() {
  return (
    <div className="auth-page">
      <Navbar />
      <div className="auth-container">
        <div className="auth-card" style={{ maxWidth: 480 }}>
          <div className="auth-header">
            <UserPlus size={28} />
            <h1>Join the Beta</h1>
            <p>token-kit is currently in private beta</p>
          </div>

          <div className="register-beta-notice">
            <ShieldCheck size={20} />
            <div>
              <strong>Invitation Only</strong>
              <p>
                During the beta period, developer accounts are created by our team.
                We're onboarding partners in batches to ensure quality and stability.
              </p>
            </div>
          </div>

          <div className="register-steps">
            <h3>How to get access</h3>
            <ol>
              <li>
                <span><strong>Request an invitation</strong> — reach out via the
                contact option below.</span>
              </li>
              <li>
                <span><strong>We'll review your use case</strong> — tell us what you're
                building and how you plan to integrate LLM features.</span>
              </li>
              <li>
                <span><strong>Get onboarded</strong> — you'll receive an email with your
                login credentials and a sandbox API key ready to go.</span>
              </li>
            </ol>
          </div>

          <div className="register-contact">
            <a
              href="mailto:contact@codetunezstudios.com?subject=token-kit%20Beta%20Access%20Request"
              className="btn btn-accent btn-block"
            >
              <Mail size={16} /> Request Access via Email
            </a>
          </div>

          <div className="register-footer">
            <p>
              Already have an account?{' '}
              <Link to="/login">Sign in</Link>
            </p>
            <p>
              <Link to="/">
                <ArrowLeft size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                Back to home
              </Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
